export const iconFontAwesomeLogisticsTruckArrowRight = (
	<i className="fa-solid fa-truck-arrow-right"></i>
);
